import api from '../config/axiosConfig';

const workOrderService = {
  // Obtener todas las órdenes de trabajo
  getAllWorkOrders: async (page = 0, size = 10, sortBy = 'createdAt', sortDir = 'desc') => {
    try {
      const response = await api.get('/work-orders', {
        params: { page, size, sortBy, sortDir }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching work orders:', error);
      throw error;
    }
  },

  // Obtener orden de trabajo por ID
  getWorkOrderById: async (id) => {
    try {
      const response = await api.get(`/work-orders/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching work order:', error);
      throw error;
    }
  },

  // Obtener orden de trabajo por número
  getWorkOrderByNumber: async (orderNumber) => {
    try {
      const response = await api.get(`/work-orders/by-number/${orderNumber}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching work order by number:', error);
      throw error;
    }
  },

  // Crear orden de trabajo desde cotización
  createFromQuotation: async (quotationId) => {
    try {
      const response = await api.post(`/work-orders/from-quotation/${quotationId}`);
      return response.data;
    } catch (error) {
      console.error('Error creating work order from quotation:', error);
      throw error;
    }
  },

  // Obtener órdenes por estado
  getWorkOrdersByStatus: async (status) => {
    try {
      const response = await api.get(`/work-orders/by-status/${status}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching work orders by status:', error);
      throw error;
    }
  },

  // Obtener órdenes programadas para hoy
  getTodayWorkOrders: async () => {
    try {
      const response = await api.get('/work-orders/today');
      return response.data;
    } catch (error) {
      console.error('Error fetching today work orders:', error);
      throw error;
    }
  },

  // Obtener órdenes pendientes
  getPendingWorkOrders: async () => {
    try {
      const response = await api.get('/work-orders/pending');
      return response.data;
    } catch (error) {
      console.error('Error fetching pending work orders:', error);
      throw error;
    }
  },

  // Obtener órdenes vencidas
  getOverdueWorkOrders: async () => {
    try {
      const response = await api.get('/work-orders/overdue');
      return response.data;
    } catch (error) {
      console.error('Error fetching overdue work orders:', error);
      throw error;
    }
  },

  // Actualizar estado de orden de trabajo
  updateStatus: async (id, status, reason = '') => {
    try {
      const response = await api.put(`/work-orders/${id}/status`, {
        status,
        reason
      });
      return response.data;
    } catch (error) {
      console.error('Error updating work order status:', error);
      throw error;
    }
  },

  // Actualizar orden de trabajo
  updateWorkOrder: async (id, workOrderData) => {
    try {
      const response = await api.put(`/work-orders/${id}`, workOrderData);
      return response.data;
    } catch (error) {
      console.error('Error updating work order:', error);
      throw error;
    }
  },

  // Eliminar orden de trabajo
  deleteWorkOrder: async (id) => {
    try {
      const response = await api.delete(`/work-orders/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting work order:', error);
      throw error;
    }
  },

  // Obtener estadísticas de órdenes de trabajo
  getStatistics: async () => {
    try {
      const response = await api.get('/work-orders/statistics');
      return response.data;
    } catch (error) {
      console.error('Error fetching work order statistics:', error);
      throw error;
    }
  },

  // Buscar órdenes de trabajo
  searchWorkOrders: async (searchParams) => {
    try {
      const response = await api.get('/work-orders/search', {
        params: searchParams
      });
      return response.data;
    } catch (error) {
      console.error('Error searching work orders:', error);
      throw error;
    }
  },

  // Obtener órdenes de trabajo con filtros avanzados
  getWorkOrdersWithFilters: async (filters) => {
    try {
      const response = await api.get('/work-orders', {
        params: filters
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching work orders with filters:', error);
      throw error;
    }
  }
};

export default workOrderService;
